import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import LOGO from '../assets/img/person/logo.webp'

const navItems = [
  { to: '/', label: 'Home', end: true },
  { to: '/services', label: 'My Services' },
  { to: '/works', label: 'My Works' },
  { to: '/contact', label: 'Contact' },
]

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false)

  const downloadCV = () => {
    const link = document.createElement('a')
    link.href = '/cv/Noor_Muhammad_Software_Engineer.pdf'
    link.download = 'Noor_Muhammad_Software_Engineer.pdf'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    setMenuOpen(false)
  }

  return (
    <div className="mil-top-panel">
      <NavLink to="/" className="mil-logo">
        <span className="mil-dot">
          <img src={LOGO} alt="Logo" width={50} />
        </span>
      </NavLink>

      <div className={`mil-navigation${menuOpen ? ' mil-active' : ''}`}>
        <nav id="swupMenu" className="mil-menu-transition">
          <ul>
            {navItems.map((item) => (
              <li key={item.to} className="mil-has-children">
                <NavLink
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) => (isActive ? 'mil-active' : undefined)}
                  onClick={() => setMenuOpen(false)}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}

            {/* Download CV */}
            <li className="mil-has-children">
              <a
                class="download-btn"
                href="/cv/Noor_Muhammad_Software_Engineer.pdf"
                download="Noor_Muhammad_Software_Engineer.pdf"
              >
                Download My CV

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-download"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <div className="mil-top-panel-btns">
        <NavLink to="/contact" className="mil-contact-btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-mail"
          >
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2-2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
          </svg>
        </NavLink>

        <div
          className="mil-menu-btn"
          role="button"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span></span>
        </div>
      </div>
    </div>
  )
}